import type { infer as zInfer } from "zod";
import { object, enum as zEnum } from "zod";

export const setBigcommerceRefundMethod = {
  name: "setBigcommerceRefundMethod" as const,
  input: object({ refundMethod: zEnum(["default", "noop"]) }),
  output: object({ success: object({}).optional() }),
};

export type SetBigcommerceRefundMethodInput = zInfer<
  typeof setBigcommerceRefundMethod.input
>;
export type SetBigcommerceRefundMethodOutput = zInfer<
  typeof setBigcommerceRefundMethod.output
>;
